function initAccordions(){

    const accordions = document.querySelectorAll('.accordion');
    const header_buttons = document.querySelectorAll('.accordion .accordion-item .accordion-header button.accordion-button');
    const collapse_items = document.querySelectorAll('.accordion .accordion-item .accordion-collapse');


    accordions.forEach( (accordion) => {
        var accordion_items = accordion.querySelectorAll('.accordion-item');

        accordion_items.forEach( (item) => {
            
            var header_button = item.querySelector('.accordion-header button.accordion-button');
            var collapse  = item.querySelector('.accordion-collapse');
            
            header_button.addEventListener( 'click', () => {
                var collapse_item_h = collapse.querySelector('.accordion-body').offsetHeight;
                var is_open = header_button.getAttribute('aria-expanded');

                if(is_open == "false"){

                    header_buttons.forEach((btn) => {
    
                        if(btn != header_button){
                            btn.setAttribute('aria-expanded', "false");
                        }
                    });
    
                    collapse_items.forEach((itm) => {
                        if(itm != collapse){
                            var collapse_itm_h = itm.querySelector('.accordion-body').offsetHeight;
                            collapseItem(itm, collapse_itm_h, true );                    
                        }
                    });
                }

                // collapse.classList.add('show');

                if(is_open == "false"){
                    collapseItem(collapse, collapse_item_h, false );
                    header_button.setAttribute('aria-expanded', "true");
                }else{
                    collapseItem(collapse, collapse_item_h, true );
                    header_button.setAttribute('aria-expanded', "false");
                }


            });

        });
        

    });
    
}


function collapseItem(collapse_obj, height, closing = false){
    collapse_obj.setAttribute('style', 'height:'+height+'px');
    const timing = getComputedStyle(document.documentElement).getPropertyValue('--smx-timing-normal') * 1000;

    if(closing){
        collapse_obj.classList.remove('show');
        collapse_obj.classList.add('collapsing');
        
        setTimeout(()=>{
            collapse_obj.removeAttribute('style');
        }, 10);

        setTimeout(()=>{
            collapse_obj.classList.remove('collapsing');
        }, timing);
    }else{
        collapse_obj.classList.add('collapsing');
        setTimeout(()=>{
            collapse_obj.classList.add('show');
            collapse_obj.classList.remove('collapsing');
        }, timing);
    }
}

export default { initAccordions }